<template>
  <b-modal
        scrollable
    id="edit-article-in-pending-modal"
    ref="modal"
    header-class="headerModal"
    centered
    size="s"
    :title="`${$t('EditArticleInPending')}: ${clickedArticleNumber}`"
    hide-footer
    @hide="onCancel"
  >
    <div>
      <b-form-group
        :label="$t('Quantity')"
      >
        <b-form-input
          v-model="amountOfProduct"
          disabled
        />
      </b-form-group>
      <b-form-group
        :label="$t('NewQuantity')"
      >
        <b-form-input
          v-model.number="newAmount"
        />
        <p
          v-if="(newAmount <= 0 || newAmount == null || newAmount == '') && buttonSubmited"
          style="color: red;"
        >
          {{ $t('Quantity') }} > 0
        </p>
      </b-form-group>
      <b-form-group
        :label="$t('Notes')"
      >
        <b-form-textarea
          v-model="notes"
        />
      </b-form-group>
    </div>
    <div class="buttonsEverywhere">
      <button
        type="button"
        variant="none"
        style="margin-left: 0px;"
        class="buttonSubmit"
        @click="onSubmit"
      >
      <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <b-button
        type="reset"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'


export default {
  props: ['amountOfProduct', 'clickedProductMovementId', 'clickedArticleNumber'],
  data() {
    return {
      loading: false,
      buttonSubmited: false,
      newAmount: 0,
      notes: null,
    }
  },
  computed: {
    ...mapGetters([
    ]),
  },
  methods: {
    ...mapActions([
      'loadEditProductInStockMovement',
    ]),
    async onSubmit() {
      this.buttonSubmited = true
      if ((this.newAmount <= 0 || this.newAmount == null || this.newAmount == '')) {
        return
      }
      const objekti = {
        productInStockMovementId: this.clickedProductMovementId,
        amount: this.newAmount,
        notes: this.notes,
      }
      try {
        this.loading = true
        await this.loadEditProductInStockMovement({
          object: objekti,
          successCallback: () => {
            this.loading = false
            this.$refs.modal.hide();
            this.onReset();
            this.$emit('updateProductsInStockMovement');
          },
        });
      } catch (error) {
        this.loading = false
      }
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.newAmount = 0
      this.notes = null
      this.loading = false
      this.buttonSubmited = false
      this.$refs.modal.hide();
    },
  },
}
</script>

  <style lang="scss" scoped>

  </style>
